import React, { useState, useEffect } from "react";

import getRandomImage from "../../data/getRandomImage";
import styles from "./Work.module.css";

const Work = ({ data, loading, error }) => {
  const [newData, setNewData] = useState(data);

  const clickhandle = (arg) => {
    window.open(arg.link, "_blank");
  };

  const STORAGE_KEY = "WorkDataCache_v1";

  // on mount, try to restore cached data if incoming prop is empty/undefined
  useEffect(() => {
    try {
      const cached = localStorage.getItem(STORAGE_KEY);
      if (cached) {
        const parsed = JSON.parse(cached);
        if ((!data || data.length === 0) && Array.isArray(parsed) && parsed.length > 0) {
          setNewData(parsed);
        }
      }
    } catch (err) {
      console.warn("Failed to read work cache:", err);
    }
  }, [data]);

  // whenever data prop updates, update state and persist to localStorage
  useEffect(() => {
    if (Array.isArray(data) && data.length > 0) {
      setNewData(data);
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      } catch (err) {
        console.warn("Failed to write work cache:", err);
      }
    }
  }, [data]);

  return (
    <>
      <h1 className="work">My Work</h1>
      <div className={styles.section_wrapper}>
        {newData && newData.length > 0 &&
          newData.map((curr, index) => {
            let bgimage = getRandomImage().toString();
            return (
              <div key={index} className={styles.folio_card} onClick={() => clickhandle(curr)}>
                <img src={bgimage} alt={curr.name} />
                <div className={styles.folio_title_descr}>
                  <h3>{curr.name}</h3>
                  <span>{curr.type}</span>
                  <p>{curr.descr}</p>
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
};

export default Work;
